import {createContext} from 'react';
import {IProps, IAuth} from '../../interfaces/storage/contexts/IAuthContext';

const AuthDefault: IAuth = {
    isAuth: false
}


export const AuthContext = createContext<IProps>({auth: AuthDefault, setAuth: null});